import React from 'react';
import { motion } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/cBD5bJboeZC4huB9HRmmrf/hoja_1.webp', 'https://cdn.magicpatterns.com/uploads/sKsjRnBhQuMA6YPc4z5RRd/hoja_2.webp', 'https://cdn.magicpatterns.com/uploads/i9mnr5JJE1drpGkhQwWgJT/hoja_3.webp', 'https://cdn.magicpatterns.com/uploads/ofHfF1HWwZCzPxWnRRrHtm/hoja_4.webp', 'https://cdn.magicpatterns.com/uploads/1Yqgy9yc6RgtLtk9MnLrbn/hoja_5.webp'];
export function ImageCarousel() {
  // Duplicate the images array to create a seamless loop
  const duplicatedImages = [...images, ...images];
  return <section className="py-12 bg-[#2C2541] overflow-hidden" data-id="element-139">
      <div className="relative flex" data-id="element-140">
        <motion.div className="flex gap-4 px-4" animate={{
        x: [0, -1250] // Adjust based on image width + gap
      }} transition={{
        duration: 40,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-141">
          {duplicatedImages.map((src, index) => <div key={index} className="shrink-0 w-[250px] md:w-[350px] aspect-[3/4] overflow-hidden rounded-xl" data-id="element-142">
              <img src={src} alt={`Preview ${index + 1}`} className="w-full h-full object-cover" data-id="element-143" />
            </div>)}
        </motion.div>
      </div>
    </section>;
}